import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { addgasten } from "../Reducers/actions";
import { useParams, useNavigate } from "react-router-dom";
import EditGastForm from "./Components/insert";

const KampeerplaatsEditPage = ({ addgasten, bedrijf }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const params = useParams();
  const navigate = useNavigate();

  const submitgast = (vals) => {
    setLoading(true);
    setError(null);

    addgasten(vals).then((data) => {
      setLoading(false);
      if (data.type === "GASTEN_VERBRUIK_ERROR") {
        // Extract the actual error message from the server response
        const errorMessage = data.error?.data?.global ||
                           data.error?.message ||
                           "Er is een onbekende fout opgetreden";
        setError(errorMessage);
        return false;
      } else {
        navigate("/gastenverbruik/gasten");
      }
    }).catch((err) => {
      setLoading(false);
      setError("Er is een fout opgetreden bij het opslaan van de gast");
    });
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Gast Toevoegen</h3>
      </div>
      <div className="box box-default">
        <div className="box-body">
          {error && (
            <div className="alert alert-danger alert-dismissible">
              <button type="button" className="close" onClick={() => setError(null)} aria-hidden="true">×</button>
              <h4><i className="icon fa fa-ban"></i> Fout!</h4>
              {error}
            </div>
          )}
          <EditGastForm onSubmit={submitgast} bedrijf={bedrijf} loading={loading} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gast: state.gastenverbruik.gast,
  bedrijf: state.auth.user.bedrijf,
});

export default connect(mapStateToProps, { addgasten })(KampeerplaatsEditPage);
